// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__9i8Mj","image":"Header_image__U-KLL","name":"Header_name__2T9vd","info":"Header_info__3Bgvl","infoRow":"Header_infoRow__23auk"};